"use strict";

/**
 * Generate spring animation configs.
 * @param configs overridable configs.
 */
export const useBottomSheetSpringConfigs = configs => {
  return configs;
};
//# sourceMappingURL=useBottomSheetSpringConfigs.js.map